import { OrganizationEventParticipationsData } from "../../models/organizationEventParticipationsData";

export interface OrganizationEventParticipationsState {
  eventSortedData: OrganizationEventParticipationsData[];
  userSortedData: OrganizationEventParticipationsData[];
  totalProgressPercentage: number | null;
  isLoading: boolean;
}

export const ORGANIZATION_EVENT_PARTICIPATIONS_REQUEST =
  "ORGANIZATION_EVENT_PARTICIPATIONS_REQUEST";
export const ORGANIZATION_EVENT_PARTICIPATIONS_FAILURE =
  "ORGANIZATION_EVENT_PARTICIPATIONS_FAILURE";
export const SET_ORGANIZATION_EVENT_PARTICIPATIONS_EVENT_SORTED_DATA =
  "SET_ORGANIZATION_EVENT_PARTICIPATIONS_EVENT_SORTED_DATA";
export const SET_ORGANIZATION_EVENT_PARTICIPATIONS_USER_SORTED_DATA =
  "SET_ORGANIZATION_EVENT_PARTICIPATIONS_USER_SORTED_DATA";
export const CLEAR_ORGANIZATION_EVENT_PARTICIPATIONS_DATA =
  "CLEAR_ORGANIZATION_EVENT_PARTICIPATIONS_DATA";

export interface OrganizationEventParticipationsRequestAction {
  type: typeof ORGANIZATION_EVENT_PARTICIPATIONS_REQUEST;
}
export interface OrganizationEventParticipationsFailureAction {
  type: typeof ORGANIZATION_EVENT_PARTICIPATIONS_FAILURE;
}

export interface SetOrganizationEventParticipationsEventSortedDataAction {
  type: typeof SET_ORGANIZATION_EVENT_PARTICIPATIONS_EVENT_SORTED_DATA;
  eventSortedData: OrganizationEventParticipationsData[];
  totalProgressPercentage: number;
}

export interface SetOrganizationEventParticipationsUserSortedDataAction {
  type: typeof SET_ORGANIZATION_EVENT_PARTICIPATIONS_USER_SORTED_DATA;
  userSortedData: OrganizationEventParticipationsData[];
  totalProgressPercentage: number;
}

export interface ClearOrganizationEventParticipationsDataAction {
  type: typeof CLEAR_ORGANIZATION_EVENT_PARTICIPATIONS_DATA;
}
export type OrganizationEventParticipationsActionTypes =
  | OrganizationEventParticipationsRequestAction
  | OrganizationEventParticipationsFailureAction
  | SetOrganizationEventParticipationsEventSortedDataAction
  | SetOrganizationEventParticipationsUserSortedDataAction
  | ClearOrganizationEventParticipationsDataAction;
